export default {"src":"/_next/static/media/SETUP_GUIDE_PENDING.631a49ab.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};